<div class="banner">
    <img src="/assets/img/banner/2.jpg" alt="Banner">
</div>
<div class="container-fluid innerPageMenu">
    <div class="row">
        <div class="col-md-3">
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>Campus</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active">
                        <a routerLink="/campus/administrative" >  Administrative Block</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/campus/academic" >Academic Block</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/campus/music" >  Music and Art</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/campus/labs" >Laboratories</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/campus/ground" >  Ground</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/campus/transport" >Transport</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/campus/infrastructure" > Infrastructure Type</a>
                    </li>
                    
                </ul>
            </nav>
        </div>
        <div class="col-md-9">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>